module.exports = __webpack_public_path__ + "media/images/logo-3ddc324a.png";